export function getFieldType(key: string): string {
  switch (key) {
    case 'lunghezza':
    case 'larghezza':
    case 'altezza':
    case 'volume':
    case 'peso':
      return '#,##0.00'
    case 'price.purchase':
    case 'price.listing':
    case 'price.discount':
    case 'prezzo_acquisto':
    case 'prezzo_listino':
    case 'prezzo_scontato':
      return '[$€-x-euro2] #,##0.00'
    case 'qty':
    case 'moltiplicatore':
    case 'onHandQty':
    case 'availableQty':
    case 'incomingQty':
    case 'Righe':
    case 'Pezzi':
      return '0'
    case 'Prezzo di listino':
    case "Prezzo d'acquisto":
    case 'Prezzo promozione':
      return '0.00'
    case 'Data/Ora':
    case 'Data/Ora creazione':
    case 'Data/Ora inizio':
    case 'Data creazione':
    case 'Data di scadenza':
    case 'Data ordine':
    case 'Data reso':
    case 'Data arrivo':
    case 'Data rimborso':
    case 'Data arrivo merce':
    case 'Data spedizione':
    case 'Data imballo':
    case 'Rif. data':
    case 'Data inizio prelievo':
    case 'Data termine prelievo':
      return 'dd/mm/yyyy hh:mm'
    default:
      return '@'
  }
}

export function getFileDate(): string {
  const now = new Date()
  const date = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`
  const time = `${now.getHours().toString().padStart(2, '0')}-${now.getMinutes().toString().padStart(2, '0')}`
  return `${date}_${time}`
}
